export enum SubscriptionType {
    SUBSCRIPTION = "plan_id",
    ADS = "ads_id",
}
export interface SubscriptionPlanChosen {
    id: string;
    frequency: string;
    paymentMethod: String;
    isToUpdate?: boolean;
    isFree?: boolean;
    subscriptionType?: SubscriptionType;
}

export interface IPaymentOptionCard {
    plan: SubscriptionPlanChosen;
}
export interface RequestPaymentData {
    plan_id: string;
    frequency: string;
    method: string;
    email: string;
    identification: string;
}
export interface RequestAdsPaymentData {
    ads_id: string;
    method: string;
    email: string;
    identification: string;
}